import React, { Component } from 'react';
import {
  FormGroup,
  FormControl,
  HelpBlock,
  Button,
  Modal
} from 'react-bootstrap';
import { connect } from 'react-redux';

import { users } from '../../../store/actions';
import { sendPasswordResetEmail } from '../../../utils/apputils';
import logo from '../../../static/images/logo-countpicula-dark.png';
import Spinner from '../../Spinner/Spinner.js';

const mapStateToProps = state => ({
  status: state.users.status,
  error: state.users.error
});

class ForgottenPasswordEmailPromptForm_Class extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.cancel = this.cancel.bind(this);
    this.state = {
      email: ''
    };
  }

  onChange({ target: { id, value } }) {
    this.setState({
      [id]: value
    });
  }

  cancel() {
    const { dispatch } = this.props;
    dispatch(users.show_login());
  }

  onSubmit(e) {
    e.preventDefault();
    const { dispatch } = this.props;
    let { email } = this.state;
    sendPasswordResetEmail(email, dispatch);
  }

  render() {
    const { status, error } = this.props;
    return (
      <form onSubmit={this.onSubmit}>
        <FormGroup controlId="email">
          <div className="tint-box">
            <FormControl
              type="email"
              value={this.state.email}
              placeholder="Email address"
              onChange={this.onChange}
              required
            />
            <FormControl.Feedback />
          </div>
          <HelpBlock>
            Enter your email. If we recognise it, we&rsquo;ll send you a code to
            allow you to reset your password.
          </HelpBlock>
        </FormGroup>
        {(status === users.types.PROMPTING_RECOVERY_EMAIL ||
          status === users.types.SENDING_RECOVERY_EMAIL_FAILED) && (
          <div>
            <Button onClick={this.cancel} className="btn-bevel">
              Cancel
            </Button>
            <Button
              bsStyle="primary"
              className="pull-right btn-bevel"
              type="submit"
            >
              Send
            </Button>
          </div>
        )}
        {status === users.types.SENDING_RECOVERY_EMAIL_FAILED && (
          <div>
            <span className="error">{error}</span>
            <br />
          </div>
        )}
        {status === users.types.SENDING_RECOVERY_EMAIL && (
          <Spinner type="regular" />
        )}
      </form>
    );
  }
}
const ForgottenPasswordEmailPromptForm = connect(mapStateToProps)(
  ForgottenPasswordEmailPromptForm_Class
);

class ForgottenPasswordEmailPrompt extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    const { dispatch } = this.props;
    dispatch(users.logout());
  }

  render() {
    const { status } = this.props;
    const show = [
      users.types.PROMPTING_RECOVERY_EMAIL,
      users.types.SENDING_RECOVERY_EMAIL,
      users.types.SENDING_RECOVERY_EMAIL_FAILED
    ].includes(status);

    return (
      <React.Fragment>
        <Modal show={show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <h2 className="modal-title" id="m_registerLabel">
              <span>Password reset</span>
            </h2>
            <img
              className="logo-img"
              src={logo}
              width="117"
              height="75"
              alt=""
            />
          </Modal.Header>
          <Modal.Body>
            <ForgottenPasswordEmailPromptForm close={this.handleClose} />
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps)(ForgottenPasswordEmailPrompt);



// WEBPACK FOOTER //
// ./src/comps/Navbar/components/ForgottenPasswordEmail.js